export default __webpack_public_path__ + "wiggle.d8f73e.svg";